import { formatNamedDate, startOfLocalDay } from '../../lib/date/localDay';

const WEEKDAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] as const;
const DAYS_IN_WEEK = 7;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Calendar-relative day label bucketed on local-midnight boundaries, so the
 * label is stable across re-renders within a day rather than flipping on a
 * rolling 24h window.
 *
 * | when                     | example        |
 * | ------------------------ | -------------- |
 * | today (or any future)    | `Today`        |
 * | yesterday                | `Yesterday`    |
 * | 2–6 days ago             | `Friday`       |
 * | 7+ days ago              | `May 23`       |
 * | 7+ days, different year  | `May 23, 2024` |
 */
export default function formatCalendarDay(date: Date, now: Date): string {
  const dayDiff = Math.round((startOfLocalDay(now) - startOfLocalDay(date)) / MS_PER_DAY);
  if (dayDiff <= 0) {
    return 'Today';
  }
  if (dayDiff === 1) {
    return 'Yesterday';
  }
  if (dayDiff < DAYS_IN_WEEK) {
    return WEEKDAY_NAMES[date.getDay()];
  }
  // Older than a week a bare weekday would be ambiguous, so name the date.
  return formatNamedDate(date, now);
}
